import { EventEmitter, Injectable, Output } from '@angular/core';
import { Tickets } from '../model/tickets/tickets.model';
import { Incidencias } from '../model/incidencias/incidencia.model';
import { NotificacionUsuario } from '../model/incidencias/notificacionUsuario.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ComunicacionService {
    @Output() actualizar: EventEmitter<Tickets> = new EventEmitter();
    @Output() calbackk: EventEmitter<Incidencias> = new EventEmitter();
    @Output() notificar: EventEmitter<any> = new EventEmitter();
    @Output() obtenerNuevas: EventEmitter<any> = new EventEmitter();
    @Output() elimina: EventEmitter<NotificacionUsuario> = new EventEmitter();

    private MenuMovilView = new BehaviorSubject<boolean>(false);
    public customMenuMovilView = this.MenuMovilView.asObservable();
    

    public changeMenuMovilView(value: boolean): void {
        this.MenuMovilView.next(value);
    }

    actualizarTickets(ticket: Tickets): any {
        this.actualizar.emit(ticket);
    }

    actualizarCallback(mensaje: Incidencias): any {
        this.calbackk.emit(mensaje);
    }

    actualizarNotificaciones (notificacion: any): any {
        this.notificar.emit(notificacion);
    }

    obtenerrNotificaciones (): any {
        this.obtenerNuevas.emit(true);
    }

    eliminaNotificacion (notificacion: NotificacionUsuario): any {
        this.elimina.emit(notificacion);
    }

}
